import { useEffect } from "react";
import { toast } from "sonner";

export const EmailConfirmationToast = () => {
  useEffect(() => {
    // Check if URL hash contains email confirmation tokens
    const hash = window.location.hash;
    if (hash && hash.includes("type=signup") && hash.includes("access_token")) {
      // Small delay to ensure the page is ready
      setTimeout(() => {
        toast.success("Email verified successfully!", {
          description: "Your account is now active. Welcome!",
          duration: 5000,
        });
        // Clean up the URL hash
        window.history.replaceState(null, "", window.location.pathname);
      }, 500);
    }
  }, []);

  return null;
};
